var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FqMallFullScreenProtocol',{attrs:{"contract-list":_vm.contractList,"product-ids":_vm.productIds,"from":_vm.from,"apply-amount":"200000"},on:{"apply-success":_vm.applySuccessCallback}})}
var staticRenderFns = []

export { render, staticRenderFns }